import React from "react";

export const AppPropsContext = React.createContext({});
